import { useState } from "react";
import CustomerService from "../../../../rest/customerService";
import CustomButton from "../../../../components/lib/customButton";

const StudentSearch = ({ onSelectStudent, excludedIds = [] }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        if (!query) return;
        setLoading(true);
        try {
            const data = await CustomerService.getStudentsByInput(query);

            const filtered = data.filter(
                s => !excludedIds.includes(s.id)
            );

            setResults(filtered);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold text-custom_gray_font">
                Adicionar aluno
            </p>

            <div className="flex gap-2">
                <input
                    className="border rounded w-full px-3 py-1.5 text-sm"
                    placeholder="Buscar aluno por nome ou login..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <CustomButton
                    buttonType="search"
                    type="button"
                    onClick={handleSearch}
                />
            </div>

            <ul className="border rounded divide-y max-h-48 overflow-y-auto">
                {results.map((student) => (
                    <li
                        key={student.id_student}
                        className="p-3 hover:bg-gray-100 cursor-pointer"
                        onClick={() => onSelectStudent(student)}
                    >
                        <p className="font-medium">{student.name}</p>
                        <p className="text-xs text-gray-500">{student.login}</p>
                    </li>
                ))}

                {!loading && results.length === 0 && (
                    <li className="p-3 text-sm text-gray-400">
                        Nenhum aluno encontrado
                    </li>
                )}
            </ul>
        </div>
    );
};

export default StudentSearch;
